<template>
  <span class="tooltip-wrapper" tabindex="-1" @blur="displayTip = false">
    <span class="inline-block" @mouseenter="toggleTip" @mouseleave="toggleTip"
      >
      <slot></slot>
    </span>

    <div class="tooltip-info my-3 mx-auto" v-if="displayTip">
      <p class="">{{ text }}</p>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    text: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      displayTip: false,
    };
  },
  methods: {
    toggleTip() {
      this.displayTip = !this.displayTip;
    },
  },
};
</script>

<style lang="scss" scoped>
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}
.tooltip-info {
  position: absolute;
bottom: 20px;
margin: 0 auto;
  color: black;
  background: white;
  width: 12rem;
  padding: 0.5rem;
  z-index: 999;
  border-radius: 0.25rem;
  p {
    font-size: 0.7rem;
  }
}
</style>
